import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@certa/catalyst/components/Dropdown";
import { ChevronDown } from "@certa/icons/components/ChevronDown";
import { Fragment } from "react";
import { useNavigate } from "react-router";
import type {
  BreadcrumbGoToDropdownProps,
  BreadcrumbLink
} from "../Breadcrumb.types";
import { BreadcrumbGoToDropdownStyles as styles } from "./BreadcrumbGoToDropdown.styles.ts";
import {
  Ellipsis,
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { CatalystColors } from "@certa/catalyst/constants/styles";

const BreadcrumbGoToDropdown = ({
  goToText,
  goToLinks,
  onLinkClick,
  menuWidth
}: BreadcrumbGoToDropdownProps) => {
  const navigate = useNavigate();

  const onRedirect = (link: BreadcrumbLink) => {
    if (link.url) {
      navigate(link.url);
    }
    if (link.onClick) {
      link.onClick();
    }
    onLinkClick?.();
  };

  return (
    <li className={styles.container}>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <button
            className={styles.triggerButton}
            aria-label={`${goToText} - View child pages`}
          >
            <Typography
              color={TypographyColors.NEUTRAL_700}
              variant={TypographyVariants.LABEL_SM}
              as="span"
              className="overflow-hidden"
            >
              <Ellipsis>{goToText}</Ellipsis>
            </Typography>
            <ChevronDown
              className={styles.chevronDown}
              color={CatalystColors.NEUTRAL_700}
              size={12}
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent width={menuWidth}>
          <Fragment>
            {goToLinks.map((link, index) => (
              <DropdownMenuItem
                key={index}
                onSelect={() => onRedirect(link)}
                value={link.label}
              >
                {link.leftIcon &&
                  link.leftIcon({
                    color: CatalystColors.NEUTRAL_700,
                    size: 16,
                    className: styles.leftIcon
                  })}
                {link.label}
              </DropdownMenuItem>
            ))}
          </Fragment>
        </DropdownMenuContent>
      </DropdownMenu>
    </li>
  );
};

export { BreadcrumbGoToDropdown };
